// eslint-disable-next-line import/no-cycle
import {
  TextAlignValueEnum,
  ComponentNameEnum,
  StepperSignEnum,
  WidgetTypeEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import {
  recalculateLineHeightValue,
  setCssProperty,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getCssPropertyByName,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getTextAlignFieldConfig from '@/components/template-builder/config/fields/text-align-config';
// eslint-disable-next-line import/no-cycle
import fontFieldConfig from '@/components/template-builder/config/fields/font-config';
// eslint-disable-next-line import/no-cycle
import lineHeightFieldConfig from '@/components/template-builder/config/fields/line-height-config';
// eslint-disable-next-line import/no-cycle
import getStepperFieldConfig from '@/components/template-builder/config/fields/stepper-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';

const listFields = [
  { label: 'templateBuilder.fields.lastname', value: 'spm_form_registration_last_name' },
  { label: 'templateBuilder.fields.firstname', value: 'spm_form_registration_first_name' },
  { label: 'templateBuilder.fields.email', value: 'spm_form_registration_email' },
  { label: 'templateBuilder.fields.password', value: 'spm_form_registration_password' },
  { label: 'templateBuilder.fields.birthday', value: 'spm_form_registration_birthday' },
];

const getFormFieldsFieldConfig = (defaultValue = [], mandatoryFields: string[] = []) => ({
  componentName: ComponentNameEnum.MULTIDROPDOWN,
  options: {
    list: listFields,
    defaultValue,
    mandatoryFields,
  },
});

export const getFormFieldContactPropertyConfig = (options = {}) => ({
  componentName: ComponentNameEnum.FORM_FIELD_CONTACT_PROPERTY,
  options,
});

export const getFormFieldOptionsPropertyConfig = () => ({
  componentName: ComponentNameEnum.FORM_FIELD_OPTIONS,
  options: {},
});

export const getCommonFormTextStylesConfig = (selector: string) => [
  {
    label: 'templateBuilder.fields.font',
    selector,
    properties: [
      { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty] },
      { name: 'font-size', getter: getCssPropertyByName, setters: [recalculateLineHeightValue, setCssProperty] },
      { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
      { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
      { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
      { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
      { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty] },
    ],
    ...fontFieldConfig,
  },
  {
    label: 'templateBuilder.fields.marginVertical',
    selector,
    properties: [
      { name: 'margin-top', getter: getCssPropertyByName, setters: [setCssProperty] },
      { name: 'margin-bottom', getter: getCssPropertyByName, setters: [setCssProperty] },
    ],
    ...getVerticalSpacesFieldConfig('margin'),
  },
  {
    label: 'templateBuilder.fields.marginHorizontal',
    selector,
    properties: [
      { name: 'margin-left', getter: getCssPropertyByName, setters: [setCssProperty] },
      { name: 'margin-right', getter: getCssPropertyByName, setters: [setCssProperty] },
    ],
    ...getHorizontalSpacesFieldConfig('margin'),
  },
  {
    label: 'templateBuilder.fields.lineHeight.label',
    selector,
    properties: [{ name: 'line-height', getter: getCssPropertyByName, setters: [setCssProperty] }],
    ...lineHeightFieldConfig,
  },
  {
    label: 'templateBuilder.fields.spaceBetweenChars',
    selector,
    properties: [{ name: 'letter-spacing', getter: getCssPropertyByName, setters: [setCssProperty] }],
    ...getStepperFieldConfig(StepperSignEnum.PX),
  },
  {
    label: 'templateBuilder.fields.textAlign',
    selector,
    properties: [{
      name: 'text-align',
      getter: getCssPropertyByName,
      setters: [setCssProperty],
    }],
    ...getTextAlignFieldConfig(TextAlignValueEnum.LEFT),
  },
];

export const getFormFieldsConfigs = () => ({
  [WidgetTypeEnum.INPUT_EMAIL]: ['showLabelInside', 'contactProperty', 'fieldRequired'],
  [WidgetTypeEnum.INPUT_TEXT]: ['showLabelInside', 'contactProperty', 'fieldRequired'],
  [WidgetTypeEnum.INPUT_PHONE]: ['showLabelInside', 'contactProperty', 'fieldRequired', 'defaultCountry'],
  [WidgetTypeEnum.INPUT_PASSWORD]: ['showLabelInside', 'contactProperty', 'fieldRequired'],
  [WidgetTypeEnum.TEXTAREA]: ['showLabelInside', 'contactProperty', 'fieldRequired'],
  [WidgetTypeEnum.INPUT_DATE]: ['showLabelInside', 'contactProperty', 'fieldRequired', 'dateFormat'],
  [WidgetTypeEnum.INPUT_CHECKBOX]: ['showLabelInside', 'contactProperty', 'mandatory'],
  [WidgetTypeEnum.INPUT_RADIO]: ['showLabelInside', 'contactProperty', 'fieldRequired'],
  [WidgetTypeEnum.INPUT_SELECT]: ['showLabelInside', 'contactProperty', 'fieldRequired'],
});

export default getFormFieldsFieldConfig;
